import { render, staticRenderFns } from "./geneltipara.vue?vue&type=template&id=84b8b0f2&"
import script from "./geneltipara.vue?vue&type=script&lang=js&"
export * from "./geneltipara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports